export const hypotenuse = (dX, dY) => Math.sqrt(Math.pow(dX, 2) + Math.pow(dY, 2));